import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { AuthService } from "./auth.service";
import { Message } from "../server/messages/general";


export interface ResetPasswordModalContext {
  objectId: number
}

@Component({
  template: `
    <div class="modal-header">
      <button
        type="button"
        class="close"
        (click)="dialog.dismiss()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title">
        Change Password
      </h4>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" (submit)="submit()">
        <div class="form-group">
          <label>New Password</label>
          <input type="password" class="form-control" [formControl]="newPassword">
        </div>
      </form>
    </div>
  
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-default"
        (click)="dialog.dismiss()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="submit()">
        Submit
      </button>
    </div>
    `,
  styles: [
    "/deep/ prettyjson pre {outline: none !important;}",
    "/deep/ #sendButton {position: relative; top: -8px;}"
  ]
})
export class ResetPasswordModalComponent implements ModalComponent<ResetPasswordModalContext>, OnInit {
  public newPassword: FormControl;
  public form: FormGroup;

  private objectId: number;

  constructor(
    public dialog: DialogRef<ResetPasswordModalContext>,
    public auth: AuthService
  ) {
    this.objectId = dialog.context.objectId;
  }

  public ngOnInit(): void {
    this.newPassword = new FormControl("", Validators.required);
    this.form = new FormGroup({
      newPassword: this.newPassword
    });
  }

  public submit(): void {
    this.auth.resetPassword(this.objectId, this.newPassword.value).subscribe((result: Message) => {
      this.dialog.close((result as any).ok);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/reset-password-modal.component.ts